function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.355 11.283a4.53 4.53 0 001.27-3.148v-.239c0-2.522-2.065-4.568-4.61-4.568H6.08a.643.643 0 00-.643.642v15.917c0 .382.31.691.692.691h7.47c2.742 0 4.963-2.208 4.963-4.933v-.258a4.923 4.923 0 00-2.207-4.104zM7.687 5.578h5.267c1.338 0 2.421 1.04 2.421 2.327v.223c0 1.284-1.085 2.328-2.421 2.328H7.687V5.578zm8.593 10.064c0 1.474-1.212 2.67-2.707 2.67H7.687v-5.593h5.886c1.495 0 2.707 1.196 2.707 2.67v.253z"
})));